export default {
    loginAndGoHome: function (res) {
        app.campaign.setCampaign(res.client.campaign);
        app.storage.setToken(res.token);
        app.storage.setRefreshToken(res.refreshToken);
        app.storage.setCandidate(res.client);
        app.state.loggedIn = app.api.isTokenValid(res.refreshToken);
        app.events.fire.navigate('home.html');
    },

    // click handler for DOM events
    logout: function () {
        const domain = app.campaign.isNewFlow() ? '/games/login?c=' : 'index.html?c='
        const logoutDestination = domain + app.storage.getCampaign().id;
        app.api.logout(() => {
            app.storage.clear();
            app.events.fire.navigate(logoutDestination);
        });
    },

    getName: function () {
        return (app.storage.getCandidate().firstName || '').capitalize() + ' ' + (app.storage.getCandidate().lastName || '').capitalize();
    },

    isEmailKnown: function () {
        return app.storage.getCandidate().isEmailKnown;
    },

    goToEditProfile: function () {
        const intakeDestination = app.campaign.isNewFlow() ? '/games/intake' : 'profile-page.html?mode=edit';
        app.events.fire.navigate(intakeDestination);
    }
};
